import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    startedAt: String, // ISO8601 string (or any Date‑parsable value)
    maxDuration: { type: Number }
  };

  connect() {
    this.update();
    this.timer = setInterval(() => this.update(), 1000);
    this.lastUpdateTime = Date.now();
    this.activityTimer = setInterval(() => this.checkActivity(), 2000);
  }

  disconnect() {
    clearInterval(this.timer);
    clearInterval(this.activityTimer);
  }

  checkActivity() {
    if (this.hasMaxDurationValue && this.maxDurationValue > 0 && Date.now() - this.lastUpdateTime > this.maxDurationValue * 1000) {
      this.stopTimer();
    }
  }

  stopTimer() {
    clearInterval(this.timer);
    clearInterval(this.activityTimer);
  }

  update() {
    if (!this.hasStartedAtValue || !this.startedAtValue) {
      this.element.textContent = '--:--';
      return;
    }

    const startedAt = new Date(this.startedAtValue);
    const now = new Date();

    const totalSeconds = Math.floor((now - startedAt) / 1000);
    const hours = Math.floor(totalSeconds / 60 / 60);
    const minutes = Math.floor(totalSeconds / 60) % 60;
    const seconds = totalSeconds % 60;

    if (hours > 0) {
      this.element.textContent = `${this.formatNumber(hours)}:${this.formatNumber(minutes)}:${this.formatNumber(seconds)}`;
    } else {
      this.element.textContent = `${this.formatNumber(minutes)}:${this.formatNumber(seconds)}`;
    }
  }

  formatNumber(number) {
    return number.toString().padStart(2, '0');
  }
}
